import { a, b, c, d, e, f, g, h } from './sides'

const forms = {
  rechteck: {
    title: 'Rechteck',
    subtitle: '',
    typeSelection: [
      { value: 0, text: '' }
    ],
    typeSelectionId: 'kub-form-selection-rechteck',
    type: [
      {
        name: 'Rechteck',
        code: 'F01',
        factor: null,
        draftFormType: 'Rechteck',
        img: {
          src: require('../../../../../assets/img/forms/formsRechteck.svg'),
          alt: 'Rechteck'
        },
        cartImg: 'cartRechteck',
        desc: 'Rechteckige Innenwinkel und frei wählbare <strong>Seitenlängen a und b</strong>:',
        sideNames: {
          a: 'a',
          b: 'b'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'rechteck-laenge-a',
            inputId: 'rechteck-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-rechteck-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'b',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'b:',
            labelFor: 'rechteck-laenge-b',
            inputId: 'rechteck-laenge-b',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-rechteck-laenge-b',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          }
        ],
        rand: [a, b, c, d],
        id: 1
      }
    ],
    id: 1
  },
  dreieck: {
    title: 'Dreieck',
    subtitle: 'gleichschenklig, gleichseitig oder rechtwinklig',
    typeSelection: [
      { value: 0, text: 'gleichschenklig' },
      { value: 1, text: 'gleichseitig' },
      { value: 2, text: 'rechtwinklig' }
    ],
    typeSelectionId: 'kub-form-selection-dreieck',
    type: [
      {
        name: 'Dreieck (gleichschenklig)',
        code: 'F02',
        factor: null,
        draftFormType: 'DreieckGS',
        img: {
          src: require('../../../../../assets/img/forms/formsDreieckGS.svg'),
          alt: 'Dreieck (gleichschenklig)'
        },
        cartImg: 'cartDreieckGS',
        desc: 'Gleichschenkliges Dreieck mit frei wählbarer <strong>Seitenlänge a</strong> und <strong>Höhe h</strong>:',
        sideNames: {
          a: 'a',
          h: 'h'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'dreieckGS-laenge-a',
            inputId: 'dreieckGS-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-dreieckGS-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'h',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'h:',
            labelFor: 'dreieckGS-laenge-h',
            inputId: 'dreieckGS-laenge-h',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-dreieckGS-laenge-h',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          }
        ],
        rand: [a, b, c],
        id: 1
      },
      {
        name: 'Dreieck (gleichseitig)',
        code: 'F03',
        factor: null,
        draftFormType: 'DreieckGSE',
        img: {
          src: require('../../../../../assets/img/forms/formsDreieckGSE.svg'),
          alt: 'Dreieck (gleichseitig)'
        },
        cartImg: 'cartDreieckGSE',
        desc: 'Gleichseitiges Dreieck mit gleich großen Winkeln und gleich langer, frei wählbarer <strong>Seitenlänge a</strong>:',
        sideNames: {
          a: 'a'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'dreieckGSE-laenge-a',
            inputId: 'dreieckGSE-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-dreieckGSE-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          }
        ],
        rand: [a, b, c],
        id: 2
      },
      {
        name: 'Dreieck (rechtwinklig)',
        code: 'F04',
        factor: null,
        draftFormType: 'DreieckRW',
        img: {
          src: require('../../../../../assets/img/forms/formsDreieckRW.svg'),
          alt: 'Dreieck (rechtwinklig)'
        },
        cartImg: 'cartDreieckRW',
        desc: 'Rechtwinkliges Dreieck mit frei wählbaren <strong>Seitenlängen a und b</strong>:',
        sideNames: {
          a: 'a',
          b: 'b'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'dreieckRW-laenge-a',
            inputId: 'dreieckRW-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-dreieckRW-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'b',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'b:',
            labelFor: 'dreieckRW-laenge-b',
            inputId: 'dreieckRW-laenge-b',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-dreieckRW-laenge-b',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          }
        ],
        rand: [a, b, c],
        id: 2
      }
    ],
    id: 2
  },
  trapez: {
    title: 'Trapez',
    subtitle: 'gleichschenklig oder abgeschrägt',
    typeSelection: [
      { value: 0, text: 'gleichschenklig' },
      { value: 1, text: 'abgeschrägt, seitlich rechts' },
      { value: 2, text: 'abgeschrägt, seitlich links' },
      { value: 3, text: 'abgeschrägt, oben rechts' },
      { value: 4, text: 'abgeschrägt, oben links' },
      { value: 5, text: 'abgeschrägt, Ecke rechts' },
      { value: 6, text: 'abgeschrägt, Ecke links' }
    ],
    typeSelectionId: 'kub-form-selection-trapez',
    type: [
      {
        name: 'Trapez (gleichschenklig)',
        code: 'F05',
        factor: null,
        draftFormType: 'TrapezGS',
        img: {
          src: require('../../../../../assets/img/forms/formsTrapezGS.svg'),
          alt: 'Trapez (gleichschenklig)'
        },
        cartImg: 'cartTrapezGS',
        desc: 'Gleichschenkliges Trapez mit frei wählbaren <strong>Seitenlängen a und c</strong> sowie <strong>Höhe h</strong>:',
        sideNames: {
          a: 'a',
          c: 'c',
          h: 'h'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'trapezGS-laenge-a',
            inputId: 'trapezGS-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezGS-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'c',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'c:',
            labelFor: 'trapezGS-laenge-c',
            inputId: 'trapezGS-laenge-c',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezGS-laenge-c',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          },
          {
            name: 'h',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'h:',
            labelFor: 'trapezGS-hoehe-h',
            inputId: 'trapezGS-hoehe-h',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezGS-hoehe-h',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 3
          }
        ],
        rand: [a, b, c, d],
        id: 1
      },
      {
        name: 'Trapez (abgeschrägt, seitlich rechts)',
        code: 'F06',
        factor: null,
        draftFormType: 'TrapezSSR',
        img: {
          src: require('../../../../../assets/img/forms/formsTrapezSSR.svg'),
          alt: 'Trapez (abgeschrägt, seitlich rechts)'
        },
        cartImg: 'cartTrapezSSR',
        desc: 'Rechtwinkliges, seitlich rechts abgeschrägtes Trapez mit frei wählbaren <strong>Seitenlängen a, b und c</strong>:',
        sideNames: {
          a: 'a',
          b: 'b',
          c: 'c'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'trapezSSR-laenge-a',
            inputId: 'trapezSSR-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSSR-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'b',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'b:',
            labelFor: 'trapezSSR-laenge-b',
            inputId: 'trapezSSR-laenge-b',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSSR-laenge-b',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          },
          {
            name: 'c',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'c:',
            labelFor: 'trapezSSR-laenge-c',
            inputId: 'trapezSSR-laenge-c',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSSR-laenge-c',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 3
          }
        ],
        rand: [a, b, c, d],
        id: 2
      },
      {
        name: 'Trapez (abgeschrägt, seitlich links)',
        code: 'F07',
        factor: null,
        draftFormType: 'TrapezSSL',
        img: {
          src: require('../../../../../assets/img/forms/formsTrapezSSL.svg'),
          alt: 'Trapez (abgeschrägt, seitlich links)'
        },
        cartImg: 'cartTrapezSSL',
        desc: 'Rechtwinkliges, seitlich links abgeschrägtes Trapez mit frei wählbaren <strong>Seitenlängen a, c und d</strong>:',
        sideNames: {
          a: 'a',
          c: 'c',
          d: 'd'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'trapezSSL-laenge-a',
            inputId: 'trapezSSL-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSSL-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'c',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'c:',
            labelFor: 'trapezSSL-laenge-c',
            inputId: 'trapezSSL-laenge-c',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSSL-laenge-c',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          },
          {
            name: 'd',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'd:',
            labelFor: 'trapezSSL-laenge-d',
            inputId: 'trapezSSL-laenge-d',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSSL-laenge-d',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 3
          }
        ],
        rand: [a, b, c, d],
        id: 3
      },
      {
        name: 'Trapez (abgeschrägt, oben rechts)',
        code: 'F08',
        factor: null,
        draftFormType: 'TrapezSOR',
        img: {
          src: require('../../../../../assets/img/forms/formsTrapezSOR.svg'),
          alt: 'Trapez (abgeschrägt, oben rechts)'
        },
        cartImg: 'cartTrapezSOR',
        desc: 'Rechtwinkliges, oben nach rechts abgeschrägtes Trapez mit frei wählbaren <strong>Seitenlängen a, b und d</strong>:',
        sideNames: {
          a: 'a',
          b: 'b',
          d: 'd'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'trapezSOR-laenge-a',
            inputId: 'trapezSOR-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSOR-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'b',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'b:',
            labelFor: 'trapezSOR-laenge-b',
            inputId: 'trapezSOR-laenge-b',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSOR-laenge-b',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          },
          {
            name: 'd',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'd:',
            labelFor: 'trapezSOR-laenge-d',
            inputId: 'trapezSOR-laenge-d',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSOR-laenge-d',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 3
          }
        ],
        rand: [a, b, c, d],
        id: 4
      },
      {
        name: 'Trapez (abgeschrägt, oben links)',
        code: 'F09',
        factor: null,
        draftFormType: 'TrapezSOL',
        img: {
          src: require('../../../../../assets/img/forms/formsTrapezSOL.svg'),
          alt: 'Trapez (abgeschrägt, oben links)'
        },
        cartImg: 'cartTrapezSOL',
        desc: 'Rechtwinkliges, oben nach links abgeschrägtes Trapez mit frei wählbaren <strong>Seitenlängen a, b und d</strong>:',
        sideNames: {
          a: 'a',
          b: 'b',
          d: 'd'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'trapezSOL-laenge-a',
            inputId: 'trapezSOL-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSOL-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'b',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'b:',
            labelFor: 'trapezSOL-laenge-b',
            inputId: 'trapezSOL-laenge-b',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSOL-laenge-b',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          },
          {
            name: 'd',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'd:',
            labelFor: 'trapezSOL-laenge-d',
            inputId: 'trapezSOL-laenge-d',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSOL-laenge-d',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 3
          }
        ],
        rand: [a, b, c, d],
        id: 5
      },
      {
        name: 'Trapez (abgeschrägt, Ecke rechts)',
        code: 'F10',
        factor: null,
        draftFormType: 'TrapezSER',
        img: {
          src: require('../../../../../assets/img/forms/formsTrapezSER.svg'),
          alt: 'Trapez (abgeschrägt, Ecke rechts)'
        },
        cartImg: 'cartTrapezSER',
        desc: 'Rechtwinkliges, oben rechts abgeschrägtes Trapez mit frei wählbaren <strong>Seitenlängen a, b, c und e</strong>:',
        sideNames: {
          a: 'a',
          b: 'b',
          c: 'c',
          e: 'e'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'trapezSER-laenge-a',
            inputId: 'trapezSER-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSER-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'b',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'b:',
            labelFor: 'trapezSER-laenge-b',
            inputId: 'trapezSER-laenge-b',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSER-laenge-b',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          },
          {
            name: 'c',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'c:',
            labelFor: 'trapezSER-laenge-c',
            inputId: 'trapezSER-laenge-c',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSER-laenge-c',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 3
          },
          {
            name: 'e',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'e:',
            labelFor: 'trapezSER-laenge-e',
            inputId: 'trapezSER-laenge-e',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSER-laenge-e',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 4
          }
        ],
        rand: [a, b, c, d, e],
        id: 6
      },
      {
        name: 'Trapez (abgeschrägt, Ecke links)',
        code: 'F11',
        factor: null,
        draftFormType: 'TrapezSEL',
        img: {
          src: require('../../../../../assets/img/forms/formsTrapezSEL.svg'),
          alt: 'Trapez (abgeschrägt, Ecke links)'
        },
        cartImg: 'cartTrapezSEL',
        desc: 'Rechtwinkliges, oben links abgeschrägtes Trapez mit frei wählbaren <strong>Seitenlängen a, b, d und e</strong>:',
        sideNames: {
          a: 'a',
          b: 'b',
          d: 'd',
          e: 'e'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'trapezSEL-laenge-a',
            inputId: 'trapezSEL-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSEL-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          },
          {
            name: 'b',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'b:',
            labelFor: 'trapezSEL-laenge-b',
            inputId: 'trapezSEL-laenge-b',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSEL-laenge-b',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 2
          },
          {
            name: 'd',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'd:',
            labelFor: 'trapezSEL-laenge-d',
            inputId: 'trapezSEL-laenge-d',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSEL-laenge-d',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 3
          },
          {
            name: 'e',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'e:',
            labelFor: 'trapezSEL-laenge-e',
            inputId: 'trapezSEL-laenge-e',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-trapezSEL-laenge-e',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 4
          }
        ],
        rand: [a, b, c, d, e],
        id: 7
      }
    ],
    id: 3
  },
  kreis: {
    title: 'Kreis',
    subtitle: '',
    typeSelection: [
      { value: 0, text: '' }
    ],
    typeSelectionId: 'kub-form-selection-kreis',
    type: [
      {
        name: 'Kreis',
        code: 'F12',
        factor: null,
        draftFormType: 'Kreis',
        img: {
          src: require('../../../../../assets/img/forms/formsKreis.svg'),
          alt: 'Kreis'
        },
        cartImg: 'cartKreis',
        desc: 'Der <strong>Durchmesser d</strong> ist frei wählbar:',
        sideNames: {
          d: 'd'
        },
        sides: [
          {
            name: 'd',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'd:',
            labelFor: 'kreis-durchmesser-d',
            inputId: 'kreis-durchmesser-d',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-kreis-durchmesser-d',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          }
        ],
        rand: [a],
        id: 1
      }
    ],
    id: 4
  },
  halbkreis: {
    title: 'Halbkreis',
    subtitle: '',
    typeSelection: [
      { value: 0, text: '' }
    ],
    typeSelectionId: 'kub-form-selection-halbkreis',
    type: [
      {
        name: 'Halbkreis',
        code: 'F13',
        factor: null,
        draftFormType: 'Halbkreis',
        img: {
          src: require('../../../../../assets/img/forms/formsHalbkreis.svg'),
          alt: 'Halbkreis'
        },
        cartImg: 'cartHalbkreis',
        desc: 'Der <strong>Durchmesser d</strong> ist frei wählbar:',
        sideNames: {
          d: 'd'
        },
        sides: [
          {
            name: 'd',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'd:',
            labelFor: 'halbkreis-durchmesser-d',
            inputId: 'halbkreis-durchmesser-d',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-halbkreis-durchmesser-d',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          }
        ],
        rand: [a, b],
        id: 1
      }
    ],
    id: 5
  },
  polygon: {
    title: 'Vieleck',
    subtitle: '5-Eck, 6-Eck, 7-Eck oder 8-Eck',
    typeSelection: [
      { value: 0, text: 'Pentagon, 5-Eck, gleichseitig' },
      { value: 1, text: 'Hexagon, 6-Eck, gleichseitig' },
      { value: 2, text: 'Heptagon, 7-Eck, gleichseitig' },
      { value: 3, text: 'Oktagon, 8-Eck, gleichseitig' }
    ],
    typeSelectionId: 'kub-form-selection-vieleck',
    type: [
      {
        name: 'Pentagon (5-Eck, gleichseitig)',
        code: 'F14',
        factor: null,
        draftFormType: 'Pentagon',
        img: {
          src: require('../../../../../assets/img/forms/formsPentagon.svg'),
          alt: 'Pentagon'
        },
        cartImg: 'cartPentagon',
        desc: 'Regelmäßiges 5-Eck mit gleich großen Winkeln und gleich langer, frei wählbarer <strong>Seitenlänge a</strong>:',
        sideNames: {
          a: 'a'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'pentagon-laenge-a',
            inputId: 'pentagon-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-pentagon-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          }
        ],
        rand: [a, b, c, d, e],
        id: 1
      },
      {
        name: 'Hexagon (6-Eck, gleichseitig)',
        code: 'F15',
        factor: null,
        draftFormType: 'Hexagon',
        img: {
          src: require('../../../../../assets/img/forms/formsHexagon.svg'),
          alt: 'Hexagon'
        },
        cartImg: 'cartHexagon',
        desc: 'Regelmäßiges 6-Eck mit gleich großen Winkeln und gleich langer, frei wählbarer <strong>Seitenlänge a</strong>:',
        sideNames: {
          a: 'a'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'hexagon-laenge-a',
            inputId: 'hexagon-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-hexagon-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          }
        ],
        rand: [a, b, c, d, e, f],
        id: 2
      },
      {
        name: 'Heptagon (7-Eck, gleichseitig)',
        code: 'F16',
        factor: null,
        draftFormType: 'Heptagon',
        img: {
          src: require('../../../../../assets/img/forms/formsHeptagon.svg'),
          alt: 'Heptagon'
        },
        cartImg: 'cartHeptagon',
        desc: 'Regelmäßiges 7-Eck mit gleich großen Winkeln und gleich langer, frei wählbarer <strong>Seitenlänge a</strong>:',
        sideNames: {
          a: 'a'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'heptagon-laenge-a',
            inputId: 'heptagon-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-heptagon-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          }
        ],
        rand: [a, b, c, d, e, f, g],
        id: 3
      },
      {
        name: 'Oktagon (8-Eck, gleichseitig)',
        code: 'F17',
        factor: null,
        draftFormType: 'Oktagon',
        img: {
          src: require('../../../../../assets/img/forms/formsOktagon.svg'),
          alt: 'Oktagon'
        },
        cartImg: 'cartOktagon',
        desc: 'Regelmäßiges 8-Eck mit gleich großen Winkeln und gleich langer, frei wählbarer <strong>Seitenlänge a</strong>:',
        sideNames: {
          a: 'a'
        },
        sides: [
          {
            name: 'a',
            labelDesc: 'min. 30 cm | max. 2500 cm',
            labelName: 'a:',
            labelFor: 'oktagon-laenge-a',
            inputId: 'oktagon-laenge-a',
            inputVal: null,
            inputPlaceholder: 'Angabe in cm',
            inputInvId: 'input-oktagon-laenge-a',
            inputInvFeedback: 'Bitte Eingabe überprüfen',
            id: 1
          }
        ],
        rand: [a, b, c, d, e, f, g, h],
        id: 4
      }
    ],
    id: 6
  }
}

export default {
  forms
}
